import axios from 'axios'
import { requestBaseUrl } from './initEnv'
const service = axios.create({
  baseURL: requestBaseUrl,
  //baseURL: 'http://192.168.1.2:11003',
  withCredentials: false,
  timeout: 60 * 1000 * 10
})
// 请求拦截
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => response.data,
  error => {

    if (error.request.status === 403) {

    }
    return Promise.reject(error)
  }
)

export default service